import { styled, useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { CssBaseline, Menu, MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import { ChevronLeft, ChevronRight, Menu as MenuIcon } from "@mui/icons-material";
import { Drawer } from "@mui/material";
import { List } from "@mui/material";
import { Divider } from "@mui/material";
import { AppBar as MuiAppBar, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { Button, ListItem, Box as MuiBox } from "@material-ui/core";
import { Toolbar } from "@mui/material";
import { Typography } from "@mui/material";
import { setProfile } from "../redux/actions/themeActions";
import { IconButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import UtilsService from "../libs/services/utils";
import AuthService from "../libs/services/auth";
import { Power } from "react-feather";
import Sidebar from "./Sidebar";
import menuRoutes from "./../routes/index";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import auth from "../libs/services/auth";
import { letterSpacing, spacing } from "@material-ui/system";
import { useSelector } from "react-redux";

const drawerWidth = 240;

const Boxes = styled(MuiBox)(spacing);

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    })
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
}));

class UserBasicMenu extends React.Component {


    state = {

        anchorMenu: null,
        open: false
    };

    toggleMenu = event => {
        this.setState({ anchorMenu: event.currentTarget });
    };

    closeMenu = () => {
        this.setState({ anchorMenu: null });
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: !this.state.open });
    };

    logout = async () => {

        /**
         * TODO: Start loader
         */
        UtilsService.changeProcessing(true)

        // Remove Token
        localStorage.removeItem("token-insurance");

        await AuthService.logout();

        /**
         * TODO: Stop loader
         */
        this.props.navigate(`/login`);
        UtilsService.changeProcessing(false)
        this.props.enqueueSnackbar("Logout successfully.", { variant: "success", autoHideDuration: '3s' });

        // Remove Profile Object from redux
        this.props.dispatch(setProfile(false))
    }


    render() {
        const { anchorMenu } = this.state;
        const open = Boolean(anchorMenu);

        return (
            <React.Fragment>
                <div>
                    <IconButton
                        aria-owns={open ? "menu-appbar" : undefined}
                        aria-haspopup="true"
                        onClick={this.toggleMenu}
                        color="inherit"
                    >
                        <Power />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorMenu}
                        open={open}
                        onClose={this.closeMenu}
                    >
                        {/* <MenuItem
              onClick={() => {
                this.closeMenu();
              }}
            >
              Profile
            </MenuItem> */}
                        <MenuItem onClick={this.handleClickOpen} >
                            Sign out
                        </MenuItem>
                    </Menu>
                </div>
                <div>
                    <Dialog
                        open={this.state.open}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth="xs"
                        fullWidth
                    >
                        <DialogTitle id="responsive-dialog-title">
                            {"Sign Out"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                are you sure you want to sign out.?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Disagree
                            </Button>

                            <Button onClick={this.logout} color="primary" variant="contained" className="primary-btn">
                                Agree
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </React.Fragment>
        );
    }
}

function UserMenu(props) {
    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    return <UserBasicMenu {...props} navigate={navigate} enqueueSnackbar={enqueueSnackbar} />
}

function Dashboard({ children, routes, width }) {
    const theme = useTheme();
    const location = useLocation();
    const [open, setOpen] = React.useState(true);
    const [currentRoute, setCurrentRoute] = useState({});


    useEffect(() => {
        if (menuRoutes && Array.isArray(menuRoutes)) {
            setCurrentRoute(menuRoutes.find(route => {
                return location.pathname.indexOf(route.path) === 0
            }))
        }
    }, [location]);

    const handleDrawer = () => {
        setOpen(!open);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const _user = useSelector((state) => state.themeReducer.profile)
const {image} = _user

    return (

        <Box sx={{ display: 'flex' }} className="w-full">
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        onClick={handleDrawer}
                        sx={{ mr: 2,  }}
                        aria-label="menu"
                    >
                        { open ? <ChevronLeft /> : <MenuIcon />}
                    </IconButton>

                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}
                        className="text-left"
                    >
                        {currentRoute?.id}
                    </Typography>
                    <UserMenu />
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: drawerWidth,
                        boxSizing: "border-box",
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader>
                    <ListItem className="mx-auto">
                        <img src={_user ? image : null} className="sidebar-logo" />
                        <Boxes>
                            <Typography style={{ fontWeight: 350}}>{auth.user ? auth.user.name : "Insurance Portal"}</Typography>
                            <Typography className="m-0" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Insurance Portal</Typography>
                        </Boxes>
                    </ListItem>
                    {/* <IconButton onClick={handleDrawerClose}>
                        {theme.direction === "ltr" ? <ChevronLeft /> : <ChevronRight />}
                    </IconButton> */}
                </DrawerHeader>
                <Divider />
                <List>
                    <Sidebar />
                </List>
                <Divider />
            </Drawer>
            <Main open={open}>
                <DrawerHeader />
                {children}
            </Main>
        </Box>

    );

}

export default Dashboard;